var $8f872ea59c02d67e$exports = {};
$8f872ea59c02d67e$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cor`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};


export {$8f872ea59c02d67e$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
